import { render, staticRenderFns } from "./TournamentCreate.vue?vue&type=template&id=439a8a9f&scoped=true"
import script from "./TournamentCreate.vue?vue&type=script&lang=js"
export * from "./TournamentCreate.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439a8a9f",
  null
  
)

export default component.exports